/**
 * @generated SignedSource<<e2049893ee0a607ccf3da8e0cd3fb5aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageEmployeeSchedueTypesListItem_store$data = {
  readonly employeeScheduleTypes: ReadonlyArray<{
    readonly assignedTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
  }>;
  readonly " $fragmentType": "ManageEmployeeSchedueTypesListItem_store";
};
export type ManageEmployeeSchedueTypesListItem_store$key = {
  readonly " $data"?: ManageEmployeeSchedueTypesListItem_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageEmployeeSchedueTypesListItem_store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageEmployeeSchedueTypesListItem_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "employeeScheduleTypes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeams",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "60bfc6450c5ac9d48d4cdfffb5413cd4";

export default node;
